import type { AtlasViewConfig } from 'types/contextView';

export const ATLAS_DEFAULT_VIEW_CONFIG: AtlasViewConfig = {
  type: 'atlas',
  // Built-in default rendering used when a context has no saved atlas view —
  // a sensible minimal set rather than an empty (column-less) atlas.
  nodeMolecules: [
    { type: 'NodeCounts', moleculeProps: {} },
    { type: 'NodeLabel', moleculeProps: { charLimit: 100 } },
    { type: 'NodeDetailsButton', moleculeProps: {} },
  ],
  showTraversalArrows: true,
  allowTraversalDirectionChange: true,
  showNearbyNodeCount: true,
  lockFocus: false,
  hideAddSphere: false,
};

/**
 * Shallow-merge a partial AtlasViewConfig onto the defaults.
 * Returns the base config if no override is provided.
 * type is always forced to 'atlas'.
 */
export function mergeAtlasViewConfig(
  base: AtlasViewConfig,
  override?: Partial<AtlasViewConfig>
): AtlasViewConfig {
  if (!override) return base;
  return { ...base, ...override, type: 'atlas' };
}
